<div [innerHTML]="htmlContentSafe"></div>
<div [innerHTML]="cssStylesSafe"></div>
